import { Injectable, signal } from "@angular/core";
import { PackageFilterData } from "./enrichment-list-filter.model";

/**
 * Shares the currently-applied package filter between the enrichment list and
 * its filter drawer.
 *
 * The drawer is rendered through the drawer service's template outlet and is
 * re-created on every open, so it can't keep its own form state across opens —
 * and an `@Input` doesn't reliably reach the dynamically-rendered instance
 * before `ngOnInit`. Both sides read/write this shared signal instead: the list
 * owns it (via its `appliedFilters` accessor) and the drawer seeds its form
 * from it on open, so reopening shows the filters that are in effect.
 */
@Injectable({ providedIn: "root" })
export class PackageFilterStateService {
  /** The applied filter, or `null` when none is active. */
  readonly applied = signal<PackageFilterData | null>(null);

  readonly activeSearchTerm = signal("");
}
